import _export from '../internals/export.js';
import functionBind from '../internals/function-bind.js';

var $ = _export;
var bind = functionBind; // `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind

$({
  target: 'Function',
  proto: true,
  forced: Function.bind !== bind
}, {
  bind: bind
});
